// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3VQgq","productName":"Table_productName__4r1V9"};